import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadFolderSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    let folderSummary = getState().currentFolder.sidebarData.summary;
    if (folderSummary.documentId === documentId && folderSummary.siteId === siteId) return;

    try {
      folderSummary = await dispatch(sendHttpRequest(api.loadFolderSummary(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_FOLDER_SUMMARY_SUCCEEDED, payload: { folderSummary } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      dispatch({ type: actionTypes.LOAD_FOLDER_SUMMARY_FAILED, payload: { error } });
    }
  };
}
